import { useContext } from 'react';

import { AlertsContext } from '@/feature/alerts/components/AlertsProvider';

export const useAlerts = () => {
    return useContext(AlertsContext);
};
